import React, { useState } from 'react';

import { useHistory } from 'react-router-dom';
import logoImg from '~/assets/logo.png';
import lologoClienteImg from '~/assets/cliente.png';

import swal from 'sweetalert';

import api from '~/services/api';
import qs from 'qs';

import {
  Gradient,
  Progress,
  Stack,
  Box,
  Form,
  Button,
  Input,
} from '~/components';

import {
  Container,
  Content,
  LogoClient,
  Logo,
  Information,
  Preloader,
} from './styles';

import { useAuth } from '~/hooks/authentication';

const SignIn: React.FC = () => {
  const [inLoad, setInLoad] = useState(false);

  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');

  const { signIn } = useAuth();
  const history = useHistory();

  const submitForm = async () => {
    try {
      setInLoad(true);

      const response = await api.post(
        'autenticacao',
        qs.stringify({
          email: email,
          senha: senha,
        }),
      );

      const { data } = response;

      if (!data || data.error) {
        setInLoad(false);
        return swal({
          icon: 'error',
          title: 'Falha na autenticação',
          text: data.message,
        });
      }

      const { nome, hash } = data;

      setTimeout(() => {
        signIn({
          token: hash,
          nome,
          email,
        });

        setInLoad(false);
        history.push('/dashboard');
      }, 2000);
    } catch (e) {
      setInLoad(false);

      swal({
        icon: 'error',
        title: 'Falha na autenticação',
        text: 'Erro não identificado',
      });
    }
  };

  return (
    <Gradient>
      <Container>
        <Content>
          <LogoClient>
            <img src={lologoClienteImg} alt="" />
          </LogoClient>

          <Form>
            <Stack>
              <Box>
                <Input
                  type="email"
                  placeholder="E-mail"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                />
              </Box>
              <Box>
                <Input
                  type="password"
                  placeholder="Senha"
                  value={senha}
                  onChange={e => setSenha(e.target.value)}
                  required
                />
              </Box>
            </Stack>

            <Button onClick={submitForm}>ENTRAR</Button>
          </Form>

          {inLoad ? <Progress /> : null}

          {inLoad ? (
            <Preloader>Aguarde, estamos liberando seu acesso...</Preloader>
          ) : null}

          <Information>
            <Logo>
              <div>
                <img src={logoImg} alt="Commerceplus" />
              </div>
            </Logo>
            <h2>Versão 0.0.1</h2>
          </Information>
        </Content>
      </Container>
    </Gradient>
  );
};

export default SignIn;
